/* unplugin-vue-components disabled */import script from "./General.vue?vue&type=script&setup=true&lang=js"
export * from "./General.vue?vue&type=script&setup=true&lang=js"

import "./General.vue?vue&type=style&index=0&id=4e527174&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e527174"]])

export default __exports__